import typeCheck from 'common/util/typeCheck';

export default function convertKmToFt(km) {
  typeCheck('km::Number', km);
  return km / 0.0003048;
}
